import Vue from 'vue'
import BasicFilter from './BasicFilter'
export default {
  extends: BasicFilter,
  created: function () {
    Vue.filter('dateTimeFormat', this.getDateTimeByUnixTime)
    Vue.filter('monthTimeFormat', this.getMonthTimeByUnixTime)
    Vue.filter('dateFormat', this.getDateByUnixTime)
    Vue.filter('yearFormat', this.getYearByUnixTime)
    Vue.filter('timeFormat', this.getTimeByUnixTime)
  },
  methods: {
    getYearByUnixTime: function (time, format = '-') {
      if (!time) {
        return '无'
      }
      let unixtime = parseInt(time)

      let localeDate = new Date(unixtime)
      let year = localeDate.getFullYear()
      let dateText = year
      return dateText
    },
    getDateTimeByUnixTime: function (time, format = '-') {
      if (!time) {
        return '无'
      }
      let unixtime = parseInt(time)

      let localeDate = new Date(unixtime)
      let year = localeDate.getFullYear()
      let month = localeDate.getMonth() + 1
      let day = localeDate.getDate()
      let hour = localeDate.getHours()
      let minutes = localeDate.getMinutes()
      let seconds = localeDate.getSeconds()
      let dateText = year + format + (month < 10 ? '0' + month : month) + format + (day < 10 ? '0' + day : day)
      dateText = dateText + ' ' + (hour < 10 ? '0' + hour : hour) + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds)
      return dateText
    },
    getTimeByUnixTime: function (time) {
      if (!time) {
        return '无'
      }
      let unixtime = parseInt(time)

      let localeDate = new Date(unixtime)
      let hour = localeDate.getHours()
      let minutes = localeDate.getMinutes()
      let seconds = localeDate.getSeconds()
      let dateText = (hour < 10 ? '0' + hour : hour) + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds)
      return dateText
    },
    getMonthTimeByUnixTime: function (time, format = '-') {
      if (!time) {
        return '无'
      }
      let unixtime = parseInt(time)

      let localeDate = new Date(unixtime)
      let year = localeDate.getFullYear()
      let month = localeDate.getMonth() + 1
      let day = localeDate.getDate()
      let hour = localeDate.getHours()
      let minutes = localeDate.getMinutes()
      let seconds = localeDate.getSeconds()
      let dateText = (month < 10 ? '0' + month : month) + format + (day < 10 ? '0' + day : day)
      dateText = dateText + ' ' + (hour < 10 ? '0' + hour : hour) + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds)
      return dateText
    },
    getDateByUnixTime: function (time) {
      if (!time) {
        return '无'
      }

      let unixtime = parseInt(time)

      let localeDate = new Date(unixtime)
      let year = localeDate.getFullYear()
      let month = localeDate.getMonth() + 1
      let day = localeDate.getDate()
      let dateText = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
      return dateText
    }
  }
}
